//Remove fields from Data
export const removeFields = (data, fieldsToRemove) => {
  const filteredData = { ...data }; // Create a shallow copy to avoid mutating the original object

  fieldsToRemove.forEach((field) => {
    if (filteredData.hasOwnProperty(field)) {
      delete filteredData[field];
    }
  });

  return filteredData;
};

export const queryResultsTable = ({ results }) => {
  console.log('result:', results);
  return (
    <div className="container mt-3">
      <h2>Query Results</h2>
    </div>
  );
};

//  Function to remove specific columns (properties)
export const removeColumns = (data, columnsToRemove) => {
  return data.map((item) => {
    const newItem = { ...item };
    columnsToRemove.forEach((col) => delete newItem[col]);
    return newItem;
  });
};

export const apiKey =
  '3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943';
